import React from 'react';

import StatusPanel from '../StatusPanel';

interface IToolkitExportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const ToolkitExport: React.FC<IToolkitExportProps> = ({ visible, loading, onClose }) => {
  return (
    <StatusPanel.LoadingPanel group="Toolkits: ELMA365: Export" loading={loading} visible={visible} onClose={onClose} />
  );
};

export default ToolkitExport;
